import { SET_QARA_MESSAGES, IS_LOADING, SET_QARA_ERROR } from "./constants";

// Add new constant for session id
export const SET_QARA_SESSION_ID = "/reducers/qara/SET_QARA_SESSION_ID";

const initialState = {
  messages: [],
  isLoading: false,
  error: null,
  sessionId: null, // Add sessionId to state
  
};

function QARAReducer(state = initialState, action) {
  switch (action.type) {
    case SET_QARA_MESSAGES:
      return {
        ...state,
        messages: action.data,
        error: null,
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.data,
      };
    case SET_QARA_ERROR:
      return {
        ...state,
        error: action.data,
      };
    case SET_QARA_SESSION_ID:
      return {
        ...state,
        sessionId: action.data,
      };
    
    default:
      return state;
  }
}

export default QARAReducer;
